import { render } from "./NotFoundPagePatient.vue?vue&type=template&id=81ac523e&scoped=true"
import script from "./NotFoundPagePatient.vue?vue&type=script&lang=js"
export * from "./NotFoundPagePatient.vue?vue&type=script&lang=js"

import "./NotFoundPagePatient.vue?vue&type=style&index=0&id=81ac523e&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81ac523e"]])

export default __exports__